import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import * as React from 'react';

import { Advantages } from '../../components/Advantages';
import { getTenantsAdvantagesItem } from '../../components/Advantages/utils/constants';
import { HowItWork } from '../../components/HowItWork';
import { tenantContent } from '../../components/HowItWork/constants';
import { Layout } from '../../components/Layout';
import { VIEWED_TIMEOUT } from '../../constants/timeouts';
import { useTeaserTracking } from '../../hooks/useTeaserTracking';
import { IScrollRef } from '../../types/page/scrolling';
import { useUserBrowserTheme } from '@cian/ui-kit';

export const TenantPage: React.FC<IScrollRef> = ({ howItWorkRef }) => {
  const { trackShowAdvantages, trackShowSteps } = useTeaserTracking();

  const theme = useUserBrowserTheme();
  const isDarkTheme = theme === 'dark';

  return (
    <Layout>
      <ActionAfterViewObserver callback={trackShowAdvantages} callbackDelay={VIEWED_TIMEOUT}>
        <Advantages
          testId="TenantAdvantages"
          heading="Чем он лучше обычного"
          items={getTenantsAdvantagesItem(isDarkTheme)}
        />
      </ActionAfterViewObserver>

      <ActionAfterViewObserver callback={trackShowSteps} callbackDelay={VIEWED_TIMEOUT}>
        <HowItWork content={tenantContent} howItWorkRef={howItWorkRef} />
      </ActionAfterViewObserver>
    </Layout>
  );
};
